import { atomWithReducer } from 'jotai/utils';

import { WorkspaceRole } from '../../../../../api/workspaces/getWorkspaceMembers';
import { assertUnreachable } from '../../../../../util/assertUnreachable';

export type WorkspaceInviteDialogViews =
  | 'InviteLinksView'
  | 'ActionOverlayResetLink'
  | 'ActionOverlayDisableLink';

export interface WorkspaceInviteDialogState {
  currentView: WorkspaceInviteDialogViews;
  currentMemberLinkType?: WorkspaceRole;
}

type WorkspaceInviteDialogAction =
  | { type: 'Close' }
  | {
      type: 'Open';
      payload: { view: WorkspaceInviteDialogViews; memberRole: WorkspaceRole };
    };

export const workspaceInviteDialogAtom = atomWithReducer(
  {
    currentView: 'InviteLinksView',
  },
  function (
    state: WorkspaceInviteDialogState,
    action: WorkspaceInviteDialogAction
  ): WorkspaceInviteDialogState {
    switch (action.type) {
      case 'Close': {
        return { currentView: 'InviteLinksView' };
      }
      case 'Open': {
        const { view, memberRole } = action.payload;
        return {
          currentView: view,
          currentMemberLinkType: memberRole,
        };
      }
      default: {
        assertUnreachable(action);
      }
    }
  }
);
